import { useMutation } from "react-query";
import verifyTwoFAToken from "../services/verifyTwoFAToken";

function useVerifyTwoFATokenMutation() {
  return useMutation(["verifyTwoFAToken"], verifyTwoFAToken);
}

export default useVerifyTwoFATokenMutation;
